module.exports = __webpack_public_path__ + "static/media/remove.d40403e0.svg";